import TeamRequestCardHelper from '../teamRequestCard.helper';

class TeamRequestCardActionsMobileController {
  constructor() {
    this.teamRequestCardHelper = new TeamRequestCardHelper();
  }

  getTeamRequestCardActionsMobileClasses() {
    let classes = ['mobile-buttons-container'];

    if (this.teamRequestCardHelper.isDiscard(this.request)) {
      classes.push('discard');
    }

    return classes;
  }
}

export default TeamRequestCardActionsMobileController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardActionsMobile/teamRequestCardActionsMobile.controller.js